import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import {
  applyIncrease,
  getContractData,
  getMmps,
  getPrincipalBalance,
  getProductPrincipal,
  sendDrawAmount,
} from 'actions/selfservice';
import CreditInformation from 'components/Credit24/SelfService/CreditInformation';
import ContractStatus from 'components/Credit24/SelfService/ContractStatus';
import Withdrawal from 'components/Credit24/SelfService/Withdrawal';
import Collapsible from 'components/common/controls/Collapsible';
import Button from 'components/common/Button';

const propTypes = {
  selfservice: PropTypes.object,
  authentication: PropTypes.object,
  getContractData: PropTypes.func,
  getMmps: PropTypes.func,
  sendDrawAmount: PropTypes.func,
  getProductPrincipal: PropTypes.func,
  getPrincipalBalance: PropTypes.func,
  applyIncrease: PropTypes.func,
};

class CreditInformationContainer extends Component {
  constructor() {
    super();
    this.state = {
      withdrawalRef: null,
    };
    this.getSectionRef = this.getSectionRef.bind(this);
  }

  componentDidMount() {
    const { contracts = [] } = this.props.authentication;
    contracts.forEach((contractId) => {
      this.props.getContractData(contractId, false, (contract) => {
        if (COUNTRY === 'AU') {
          if (contract.product.type === 'INSTALLMENT') {
            this.props.getProductPrincipal(contractId, contract.startDate);
            this.props.getPrincipalBalance(contractId);
          }
        }
      });
      this.props.getMmps(contractId);
    });
  }

  getSectionRef(node) {
    this.setState({
      withdrawalRef: node,
    });
  }

  render() {
    const { authentication, selfservice } = this.props;
    const { contracts } = selfservice;
    const { isInCollection } = authentication;
    const contractId = authentication.contracts[0];
    const contract = contracts[contractId] || {};
    const upgradeAvailable = contract.upgrade && contract.upgrade.product;
    const { drawBlockedReason } = contract;
    let isAUIL = false;

    const contractStatusClassName = cx({
      'content-columns__item': true,
      'content-columns__item--flex-end': isInCollection,
    });

    if (COUNTRY === 'AU') {
      isAUIL = contract.product && contract.product.type === 'INSTALLMENT';
    }

    const clOnlyItems = isAUIL ? [] : [
      <div key="withdrawal">
        {contract.id && (!drawBlockedReason || drawBlockedReason === 'DRAW_PENDING')
          && (
          <div className="content-block" ref={this.getSectionRef}>
            <Collapsible
              Title={() => (
                <FormattedMessage id="selfservice.creditInfo.withdraw" tagName="h3" />
              )}
              ButtonOpen={({ onClick }) => (
                <Button btnType={upgradeAvailable ? 'secondary' : null} onClick={onClick} isFullWidth>
                  <FormattedMessage id="selfservice.creditInfo.withdraw.open" />
                </Button>
              )}
              ButtonCloseMobile={({ onClick }) => (
                <Button btnType="secondary" onClick={onClick} isFullWidth>
                  <FormattedMessage id="selfservice.creditInfo.withdraw.close" />
                </Button>
              )}
            >
              <Withdrawal
                bankAccount={authentication.bankAccount}
                contract={contract}
                selfservice={selfservice}
                sendDrawAmount={this.props.sendDrawAmount}
                withdrawalRef={this.state.withdrawalRef}
                headerless
              />
            </Collapsible>
          </div>
          )}
      </div>,
    ];

    return [
      <div className="content-block" key="creditInfo">
        <div className="content-columns">
          <div className={contractStatusClassName}>
            <ContractStatus
              authentication={authentication}
              selfservice={selfservice}
              applyIncrease={this.props.applyIncrease}
            />
          </div>
          <div className="content-columns__item">
            {contracts[authentication.contracts[0]]
              && <CreditInformation data={contracts[authentication.contracts[0]]} />}
          </div>
        </div>
      </div>,
      ...clOnlyItems,
    ];
  }
}

CreditInformationContainer.propTypes = propTypes;

export default connect(
  (state) => ({
    selfservice: state.selfservice,
    authentication: state.authentication,
  }),
  {
    getContractData,
    getMmps,
    sendDrawAmount,
    getProductPrincipal,
    getPrincipalBalance,
    applyIncrease,
  }
)(CreditInformationContainer);
